import { Tooltip } from '@sgme/ui';
import type { PropsWithChildren } from 'react';

export function HedgeWarningTooltipWrapper({
  showWarningAlert,
  message,
  children,
}: PropsWithChildren<{ showWarningAlert: boolean; message: string }>) {
  if (!showWarningAlert) {
    return children;
  }

  return (
    <Tooltip contents={message} position="right" color="warning">
      <div>{children}</div>
    </Tooltip>
  );
}
